import styled from 'styled-components'
import { Box, Flex } from '@nominex/dex-uikit'

export const Column = styled(Flex)`
  flex-direction: column;
  justify-content: flex-start;
`
export const ColumnCenter = styled(Column)`
  width: 100%;
  align-items: center;
`

enum Gap {
  sm = 'sm',
  md = 'md',
  lg = 'lg',
}

const GAP_MAP = {
  [Gap.sm]: '8px',
  [Gap.md]: '12px',
  [Gap.lg]: '24px',
}

export const AutoColumn = styled(Box)<{
  gap?: Gap | string
  justify?: 'stretch' | 'center' | 'start' | 'end' | 'flex-start' | 'flex-end' | 'space-between'
}>`
  display: grid;
  grid-auto-rows: auto;
  grid-row-gap: ${({ gap }) => GAP_MAP[gap] ?? gap};
  justify-items: ${({ justify }) => justify && justify};
`
